exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cardCreateStory[data-v-7e7aaf69]{position:relative;top:0;width:100%;margin:0;padding-top:2em}", ""]);
